import { langDetector } from "@app/shared/lib/localization";

export const useLangDetector = () => langDetector;
